import { Fragment } from 'react';
import { Box, TextArea } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { FormSubmitButton } from './FormSubmitButton';
export function MultilineTextField() {
    const [field, meta] = useField('value');
    const error = Boolean(meta.touched && meta.error);
    return (<Fragment>
      <Box mt="sm" mx="sm">
        <TextArea stretch {...field} invalid={error}/>
      </Box>
      <FormSubmitButton />
    </Fragment>);
}
